/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useSelectedPayers
 */
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import QUERY_KEYS from 'app-constants/queryKeys';
import api from 'client/index';
import { useAppStoreValues } from 'store/app';
import { prepareSelectedPayersMeta } from 'utils/admin/payers';

/**
 * useSelectedPayers hook
 * @returns {UseQueryResult} useSelectedPayers
 */
const useSelectedPayers = (): UseQueryResult<Payers.ISelectedPayer[]> => {
	const { isEligibilityUser } = useAppStoreValues().userAccess;
	return useQuery({
		queryKey: [QUERY_KEYS.selectedPayer],
		queryFn: async () => {
			const { data } = await api.PayersApi.getPayers({ payerSearchModel: {} });
			return prepareSelectedPayersMeta(data);
		},
		enabled: isEligibilityUser,
	});
};

export default useSelectedPayers;
